import React from 'react';
import {Platform, ScrollView,StyleSheet} from 'react-native';
import WebView from 'react-native-webview';

import ContentView from '../../components/ui-controls/layout/ContentView';
import theme from '../../style/theme';

const htmlTemplate = (styleCss, bodyHtml) => `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <base target="_parent" />
  <title>Information</title>
  <style>
    ${styleCss}
  </style>
</head>
<body>
  ${bodyHtml}
</body>
</html>
`;

// TODO: We are not really using Grota on Web yet. We are using
// -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif
// and I haven't checked where is it coming from.
const contentStyle = `
  body {
    background-color: white;
    color: ${theme.colour.text.content.primary};
    font-size: 16px;
    font-family: -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
  }
  h1 {
    color: ${theme.colour.text.heading.primary};
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  h2 {
    color: ${theme.colour.text.heading.primary};
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
  }
`;

function HtmlContentScreen({html, wrapHtml = true}) {
  const finalHtml = wrapHtml ? htmlTemplate(contentStyle, html) : html;

  // WebView is not working on Web here ("nothing happens", no HTML rendering, no errors, just
  // blank screen). No time to debug it now.
  return (
    <ContentView>
      <ScrollView contentContainerStyle={styles.main}>
        {Platform.OS === 'web' ? (
          <iframe srcDoc={finalHtml} style={styles.webIFrame} />
        ) : (
          <WebView
            source={{html: finalHtml}}
            style={styles.webview}
            scrollEnabled={true}
            cacheEnabled={false}
            startInLoadingState={true}
          />
        )}
      </ScrollView>
    </ContentView>
  );
}

export default HtmlContentScreen;

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },
  webIFrame: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    border: 0,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '10px',
  },
  activityIndicator: {
    position: 'absolute',
  },
});
